import { Link, useLocation } from "react-router-dom";
import { Home, Search, FileText, User, RefreshCw, Building } from "lucide-react";
import { useAuth } from "../App";

const NAV_ITEMS_CLIENT = [
  { path: "/client", icon: Home, label: "Início" },
  { path: "/discovery", icon: Search, label: "Serviços" },
  { path: "/projects", icon: Building, label: "Obras" },
  { path: "/contracts", icon: FileText, label: "Contratos" },
  { path: "/profile", icon: User, label: "Perfil" }
];

const NAV_ITEMS_PROVIDER = [
  { path: "/provider", icon: Home, label: "Início" },
  { path: "/budgets", icon: FileText, label: "Orçamentos" },
  { path: "/contracts", icon: FileText, label: "Contratos" },
  { path: "/subscriptions", icon: RefreshCw, label: "Assinaturas" },
  { path: "/profile", icon: User, label: "Perfil" }
];

export default function BottomNavigation() {
  const location = useLocation();
  const { user } = useAuth();

  if (!user) return null;

  const navItems = user.role === "provider" ? NAV_ITEMS_PROVIDER : NAV_ITEMS_CLIENT;

  const hiddenPaths = ["/login", "/register", "/", "/diagnostic", "/negotiation", "/execution", "/payment", "/tip", "/direct-service"];
  const shouldHide = hiddenPaths.some(path => 
    location.pathname === path || location.pathname.startsWith(path + "/")
  );

  if (shouldHide) return null;

  return (
    <nav className="bottom-nav" data-testid="bottom-nav">
      {navItems.map((item) => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path || 
          (item.path !== "/client" && item.path !== "/provider" && location.pathname.startsWith(item.path));
        
        return (
          <Link
            key={item.path}
            to={item.path}
            className={`bottom-nav-item no-select ${isActive ? "active" : ""}`}
            data-testid={`nav-${item.label.toLowerCase()}`}
          >
            <Icon className="w-5 h-5" strokeWidth={isActive ? 2 : 1.5} />
            <span>{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
